// This file is a reducer, a simple method that defines
// a initial state for the store and then a switch that
// based on what action is dispatched it will return a brand new state
import * as constants from '../actions/constants'

const initialState = {
  list: []
}

const stations = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_STATIONS:
      return {
        ...state,
        list: action.stations
      }
    default:
      return state
  }
}

export default stations
